"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
	className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
	const { theme, setTheme, systemTheme } = useTheme();
	const [mounted, setMounted] = useState(false);
	const currentTheme = theme === "system" ? systemTheme : theme;
	const isDark = currentTheme === "dark";

	useEffect(() => setMounted(true), []);

	if (!mounted) {
		return (
			<Button
				variant="ghost"
				size="sm"
				className={cn("h-8 w-8 p-0 rounded-lg", className)}
				aria-label="Toggle theme"
			>
				<Sun className="h-4 w-4" strokeWidth={1.5} />
			</Button>
		);
	}

	return (
		<Button
			variant="ghost"
			size="sm"
			className={cn("h-8 w-8 p-0 rounded-lg", className)}
			onClick={() => setTheme(isDark ? "light" : "dark")}
			aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
		>
			{isDark ? (
				<Sun className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
			) : (
				<Moon className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
			)}
		</Button>
	);
}
